import { Component, OnInit } from '@angular/core';
import { UsersService, AdminRole, POSUser } from '../services/users.service'
import { FormBuilder,Validators,FormGroup } from '@angular/forms';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  isLoading = false
  user:POSUser
  form:FormGroup
  alertMsg:string
  // newPwd:string
  // pwdConfirm:string

  constructor(private authService:UsersService,private fb: FormBuilder) {
    this.user = authService.currentUser
    this.form = this.fb.group({
      displayName:[this.user.displayName,[Validators.required]],
      oldPassword:'',
      newPassword:['',this.validateNewPassword],
      passwordConfirm:''
    },{validator: this.matchingPasswords('oldPassword','newPassword', 'passwordConfirm')})
  }

  matchingPasswords(oldPasswordKey:string,passwordKey: string, passwordConfirmationKey: string) {
  return (group: FormGroup) => {
    let oldPasswordInput = group.controls[oldPasswordKey]
    let passwordInput = group.controls[passwordKey];
    let passwordConfirmationInput = group.controls[passwordConfirmationKey];

    if (!!passwordInput.value&&!oldPasswordInput.value) {
        oldPasswordInput.setErrors({noPassword: true})
    }else {
      oldPasswordInput.setErrors(null)
    }

    if (passwordInput.value !== passwordConfirmationInput.value && !!passwordInput.value) {
      passwordConfirmationInput.setErrors({notEquivalent: true})
    }else {
      passwordConfirmationInput.setErrors(null)
    }
  }
}

  validateNewPassword(form) {
    if (!!form.value && form.value.length < 6) {
        return {validateNewPassword : {errors: true}}
    }else {
      return null
    }
  }

  ngOnInit() {
  }


  imageUrl() {
    let src="./assets/img/avatars/"

    switch (this.user.role) {
      case AdminRole[AdminRole.SuperAdmin]:
        return src+"Super.png"
      case AdminRole[AdminRole.BrandAdmin]:
        return src+"BA.png"
      case AdminRole[AdminRole.StoreAdmin]:
        return src+"BA.png"
      default:
        return ""
    }
  }


  onSubmit() {
    this.alertMsg = null
    this.isLoading = true
    this.authService.updateUserProfile({displayName:this.form.value.displayName}).then(
      () => {
        this.authService.currentUser.displayName = this.form.value.displayName
        if (this.form.value.newPassword) {
          this.updatePassword()
        }else {
          this.isLoading = false
        }

      }
    ).catch(
      err => {
        alert(err.toString())
        this.isLoading = false
      }
    )
  }

  updatePassword() {
    this.authService.reauthenticate(this.form.value.oldPassword).then(
      () => {
        this.authService.updateUserPwd(this.form.value.newPassword).then(
          () => {
            this.isLoading = false
          }
        ).catch (
          err => {
            alert(err.toString())
            this.isLoading = false
          }
        )
      },
      (err) => {
        this.alertMsg = "原密碼認證失敗，請重新輸入。"
        this.form.controls.oldPassword.setValue('')
        this.form.controls.newPassword.setValue('')
        this.form.controls.passwordConfirm.setValue('')
        this.isLoading = false
      }
    )
  }

}



// WEBPACK FOOTER //
// ./src/app/profile/profile.component.ts